import React from 'react';
import { string, oneOfType, oneOf, number, func } from 'prop-types';
import { Icon, Tooltip } from '@chaser/components';

const getIntentIcon = type => {
  if (type === 'warning') return 'warning-circle';
  if (type === 'danger') return 'alert-square';
  return 'alert-square';
};

const getIntentColor = type => {
  if (type === 'warning') return 'Yellow';
  if (type === 'danger') return 'Red';
  return 'alert-square';
};

const Alert = ({
  tooltipContent,
  intent = 'danger',
  color,
  size = 20,
  className = '',
  link,
  tooltipPosition = 'right',
  tooltipClass = '',
  target,
  onClick,
  ...rest
}) => {
  const Comp = link ? 'a' : 'span';

  return (
    <span className={className} {...rest}>
      {tooltipContent ? (
        <Tooltip className={tooltipClass} content={tooltipContent} position={tooltipPosition}>
          <Comp
            href={link}
            target={target}
            rel={target && 'noopener noreferrer'}
            onClick={e => {
              e.stopPropagation();
              if (onClick) onClick(e);
            }}
          >
            <Icon
              data-testid="alert-icon"
              data-trackingid="alert-icon"
              color={color || getIntentColor(intent)}
              size={size}
              name={getIntentIcon(intent)}
            />
          </Comp>
        </Tooltip>
      ) : (
        <Comp
          href={link}
          target={target}
          rel={target && 'noopener noreferrer'}
          onClick={e => {
            e.stopPropagation();
            if (onClick) onClick(e);
          }}
        >
          <Icon color={color || getIntentColor(intent)} name={getIntentIcon(intent)} />
        </Comp>
      )}
    </span>
  );
};

export default Alert;

Alert.propTypes = {
  target: string,
  color: string,
  size: oneOfType([string, number]),
  intent: oneOf(['danger', 'warning']),
  link: string,
  tooltipContent: string,
  tooltipPosition: oneOf(['top', 'bottom', 'left', 'right']),
  className: oneOfType([string, number]),
  tooltipClass: oneOfType([string, number]),
  onClick: func,
};
